import { api } from 'roadie-ui'

export function getSetting(profileId: number, name: string) {
  return api
    .version(3)
    .get(`profiles/${profileId}/settings`)
    .then((resp: any) => resp.data.settings.find((s: any) => s.setting === name))
    .catch((err: any) => err)
}

export function applySetting(profileId: number, name: string, value: string | boolean) {
  return api.version(3).patch(`profiles/${profileId}/settings/`, { setting: name, value: value })
}

export function updateSetting(profileId: number, name: string, value: string | boolean) {
  return api.version(3).put(`profiles/${profileId}/settings/`, { setting: name, value: value })
}
